import { connect } from 'react-redux';
import { getPatientsHiddenLoadingStatus, getEditPatient } from 'store/selectors/patient';
import { requestPatientsResourceById } from 'store/actionCreators/patient';

import EditPatientsInformation from 'components/EditPatientsInformation';

const mapStateToProps = state => ({
  loading: getPatientsHiddenLoadingStatus(state),
  isData: !!getEditPatient(state),
});

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { id },
    },
  },
) => ({
  getData: () => dispatch(requestPatientsResourceById({ patientId: id })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditPatientsInformation);
